import { Container, Section } from "@/components/ui/section";
import { AlertCircle } from "lucide-react";

const problems = [
  "No bandwidth - CS, PMM, and founders are overloaded.",
  "Scaling past 200+ customers - manual interviewing becomes impossible.",
  "Content bottlenecks - case studies take forever and go stale fast.",
  "Missed insights - a tiny fraction of customers create 100% of your understanding.",
];

export const Problem = () => {
  return (
    <Section id="problem" className="bg-background">
      <Container>
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-8 leading-tight">
            You have more customers than your team can ever talk to.
          </h2>
          <div className="space-y-4 mb-8">
            {problems.map((problem, index) => (
              <div key={index} className="flex items-start gap-4 text-left bg-muted/30 rounded-lg p-4">
                <AlertCircle className="w-5 h-5 text-destructive mt-0.5 flex-shrink-0" />
                <p className="text-base sm:text-lg text-foreground">{problem}</p>
              </div>
            ))}
          </div>
          <p className="text-lg sm:text-xl text-muted-foreground italic">
            You're guessing what customers really think - and starving marketing and sales of the proof they need.
          </p>
        </div>
      </Container>
    </Section>
  );
};
